import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  applyLanguage,
  LANG_STORAGE_KEY,
  persistLanguage,
  resolveLanguage,
  SUPPORTED_LANGS,
} from "../utils/language";

function useLanguage() {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(() => {
    const current = i18n.language?.split("-")[0];
    if (SUPPORTED_LANGS.includes(current)) return current;
    return resolveLanguage();
  });

  useEffect(() => {
    applyLanguage(language);
  }, [language]);

  useEffect(() => {
    const onLanguageChanged = (lng) => {
      const next = (lng || "").split("-")[0];
      if (SUPPORTED_LANGS.includes(next)) {
        setLanguage(next);
        applyLanguage(next);
      }
    };

    i18n.on("languageChanged", onLanguageChanged);
    return () => i18n.off("languageChanged", onLanguageChanged);
  }, [i18n]);

  const toggleLanguage = useCallback(() => {
    setLanguage((current) => {
      const next = current === "am" ? "en" : "am";
      persistLanguage(next);
      i18n.changeLanguage(next);
      return next;
    });
  }, [i18n]);

  return { language, toggleLanguage, storageKey: LANG_STORAGE_KEY };
}

export default useLanguage;
